export type OperatorDataType = "string" | "number" | "date";

export type OperatorType =
  | "EQUALS"
  | "CONTAINS"
  | "STARTS_WITH"
  | "END_WITH"
  | "LESS_THAN_EQUAL"
  | "GREATER_THAN_EQUAL"
  | "BETWEEN"
  | "IS_NULL";

export type OperatorTypeOld =
  | "EQUALS"
  | "NOT_EQUAL"
  | "CONTAINS"
  | "NOT_CONTAINS"
  | "STARTS_WITH"
  | "NOT_STARTS_WITH"
  | "END_WITH"
  | "NOT_END_WITH"
  | "LESS_THAN"
  | "LESS_THAN_EQUAL"
  | "GREATER_THAN"
  | "GREATER_THAN_EQUAL"
  | "IN"
  | "BETWEEN";

export interface Operator {
  value: OperatorType;
  label: string;
  type: OperatorDataType[];
}

export const OPERATORS: Operator[] = [
  {
    value: "EQUALS",
    label: "common.dmri.filter.operators.equals",
    type: ["string", "number", "date"],
  },
  /*{
    value: "NOT_EQUAL",
    label: "common.dmri.filter.operators.notEquals",
    type: ["string", "number", "date"],
  },*/
  {
    value: "CONTAINS",
    label: "common.dmri.filter.operators.contains",
    type: ["string"],
  },
  /*{
    value: "NOT_CONTAINS",
    label: "common.dmri.filter.operators.notContains",
    type: ["string"],
  },*/
  {
    value: "STARTS_WITH",
    label: "common.dmri.filter.operators.startsWith",
    type: ["string"],
  },
  /*{
    value: "NOT_STARTS_WITH",
    label: "common.dmri.filter.operators.notStartsWith",
    type: ["string"],
  },*/
  {
    value: "END_WITH",
    label: "common.dmri.filter.operators.endsWith",
    type: ["string"],
  },
  /*{
    value: "NOT_END_WITH",
    label: "common.dmri.filter.operators.notEndsWith",
    type: ["string"],
  },*/
  //{ value: "LESS_THAN", label: "<", symbol: "<", type: ["number"] },
  {
    value: "LESS_THAN_EQUAL",
    label: "common.dmri.filter.operators.lessThan",
    type: ["number", "date"],
  },
  //{ value: "GREATER_THAN", label: ">", symbol: ">", type: ["number"] },
  {
    value: "GREATER_THAN_EQUAL",
    label: "common.dmri.filter.operators.greaterThan",
    type: ["number", "date"],
  },
  /*{
    value: "IN",
    label: "common.dmri.filter.operators.in",
    symbol: "in",
    type: ["string", "number"],
  },*/
  {
    value: "BETWEEN",
    label: "common.dmri.filter.operators.between",
    type: ["number", "date"],
  },
  {
    value: "IS_NULL",
    label: "common.dmri.filter.operators.isNull",
    type: ["string", "number"],
  },
];
